export const supportEmail = () => (
    process.env.VUE_APP_THEME === 'luxliebe' ? 'support@luxliebe.com' : 'support@sugardaddy.date'
)
